module.exports = __webpack_public_path__ + "img/40_69_003_210.50f7dd54.jpg";